__turbopack_context__.v({
  "actions": "PublicNavbar-module__Q6t_da__actions",
  "cta": "PublicNavbar-module__Q6t_da__cta",
  "dropdown": "PublicNavbar-module__Q6t_da__dropdown",
  "dropdownAll": "PublicNavbar-module__Q6t_da__dropdownAll",
  "dropdownDivider": "PublicNavbar-module__Q6t_da__dropdownDivider",
  "dropdownDot": "PublicNavbar-module__Q6t_da__dropdownDot",
  "dropdownDotActive": "PublicNavbar-module__Q6t_da__dropdownDotActive",
  "dropdownItem": "PublicNavbar-module__Q6t_da__dropdownItem",
  "dropdownItemActive": "PublicNavbar-module__Q6t_da__dropdownItemActive",
  "dropdownList": "PublicNavbar-module__Q6t_da__dropdownList",
  "header": "PublicNavbar-module__Q6t_da__header",
  "inner": "PublicNavbar-module__Q6t_da__inner",
  "link": "PublicNavbar-module__Q6t_da__link",
  "linkActive": "PublicNavbar-module__Q6t_da__linkActive",
  "links": "PublicNavbar-module__Q6t_da__links",
  "logo": "PublicNavbar-module__Q6t_da__logo",
  "logoImg": "PublicNavbar-module__Q6t_da__logoImg",
  "menuTrigger": "PublicNavbar-module__Q6t_da__menuTrigger",
  "menuWrapper": "PublicNavbar-module__Q6t_da__menuWrapper",
  "scrolled": "PublicNavbar-module__Q6t_da__scrolled",
  "triggerChevron": "PublicNavbar-module__Q6t_da__triggerChevron",
  "triggerChevronUp": "PublicNavbar-module__Q6t_da__triggerChevronUp",
});
